"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bookingJFL = void 0;
exports.bookingJFL = {
    groups: [
        {
            label: 'Booking Transaction Details',
            layout: 'flex',
            type: 'singleFields',
            fields: [
                { field: 'BookingNumber', size: '1' },
                { field: 'DateOfArrest', size: '1' },
                { field: 'BookingAgency', size: '4' },
                { field: 'Date', size: '1' },
                { field: 'TransactionControlNumber', size: '4' }
            ]
        },
        {
            label: 'Subject Details',
            type: 'singleFields',
            layout: 'flex',
            fields: [
                { field: 'FullName', size: '5' },
                { field: 'ResidenceOfPersonFingerprinted', size: '5' },
                { field: 'DateOfBirth', size: '1' },
                { field: 'CurrentAge', size: '1' },
                { field: 'BookingAge', size: '1' },
                { field: 'PlaceOfBirth', size: '3' },
                { field: 'StateIDNumber', size: '4' },
                { field: 'SocialSecurityNumber', size: '4' },
                { field: 'Sex', size: '2' },
                { field: 'Race', size: '2' },
                { field: 'EyeColor', size: '2' },
                { field: 'HairColor', size: '2' },
                { field: 'Height', size: '2' },
                { field: 'Weight', size: '2' }
            ]
        },
        {
            label: 'Mugshot Characteristics',
            type: 'singleFields',
            layout: 'flex',
            fields: [
                { field: 'MugshotPhysicalCharacteristicsSet.Glasses', size: '2' },
                { field: 'MugshotPhysicalCharacteristicsSet.HairLength', size: '2' },
                { field: 'MugshotPhysicalCharacteristicsSet.HairStyle', size: '2' },
                { field: 'MugshotPhysicalCharacteristicsSet.Complexion', size: '2' },
                { field: 'MugshotPhysicalCharacteristicsSet.Beard', size: '2' },
                { field: 'MugshotPhysicalCharacteristicsSet.Mustache', size: '2' },
                { field: 'MugshotPhysicalCharacteristicsSet.Sideburns', size: '2' },
                { field: 'MugshotPhysicalCharacteristicsSet.FacialHair', size: '2' },
                { field: 'MugshotPhysicalCharacteristicsSet.Build', size: '2' }
            ]
        },
        {
            label: 'Identifiers',
            layout: 'flex',
            type: 'singleFields',
            fields: [
                { field: 'LegacyJailIdentifier', size: '2' },
                { field: 'UCN', size: '2' },
                { field: 'FBINumber', size: '2' },
                { field: 'StateIDNumber', size: '2' },
                { field: 'LocalAFISNumber', size: '2' },
                { field: 'SocialSecurityNumber', size: '2' }
            ]
        },
        {
            label: 'Aliases',
            type: 'explicitMultipleOccurrence',
            layout: 'flex',
            options: {
                addButtonLabel: 'Add New Alias',
                newOccurrenceLabel: 'New Alias',
                editOccurrenceLabel: 'Edit Alias',
                tableFields: ['Aliases']
            },
            fields: [{ field: 'Aliases', size: 'full' }]
        },
        {
            label: 'Miscellaneous Number',
            type: 'explicitMultipleOccurrence',
            layout: 'flex',
            options: {
                addButtonLabel: 'Add New Miscellaneous Number',
                newOccurrenceLabel: 'New Miscellaneous Number',
                editOccurrenceLabel: 'Edit Miscellaneous Number',
                tableFields: ['MiscellaneousIDNumbers']
            },
            fields: [{ field: 'MiscellaneousIDNumbers', size: 'full' }]
        }
    ]
};
//# sourceMappingURL=jfl-kcso.js.map